var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.476,
    height: 24.031,
    viewBox: "0 0 25.476 24.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.021,146.9H24.455a1.062,1.062,0,0,0,.8-.35.864.864,0,0,0,.213-.69,12.891,12.891,0,0,0-6.786-9.751,8.4,8.4,0,0,1-11.89,0,12.889,12.889,0,0,0-6.786,9.751.865.865,0,0,0,.213.69A1.062,1.062,0,0,0,1.021,146.9Z",
    transform: "translate(0 -122.873)",
    fill: "#FFBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.074,19.36c.137.143.28.28.427.412a7.251,7.251,0,0,0,9.706,0c.148-.132.291-.269.427-.412s.269-.29.394-.444a7.3,7.3,0,1,0-11.349,0C54.8,19.069,54.937,19.216,55.074,19.36Z",
    transform: "translate(-47.616 -7.045)",
    fill: "#FFBB00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.0883bade0b34270cac843ce636126568.svg";
export { ForwardRef as ReactComponent };